/**
 * Enviar um projeto comprado para o Due Studio (o app de gravação, no PC do usuário).
 *
 * São três caminhos, e a diferença é onde o portal está aberto:
 *
 * 1. DENTRO do Due Studio 5 (aba "Projetos"): manda só o id por postMessage. Quem baixa o
 *    SVG é o app, com o token que ele já tem — o token não passa pela página.
 * 2. Navegador + Due Studio 5: servidor local do app na porta 51111, com o token no header.
 * 3. Navegador + Due Studio 4: a porta 3777 de sempre, com o token na URL. É o formato que
 *    o app antigo entende; não mexer.
 */

const DUE_STUDIO_5_URL = 'http://localhost:51111';
const DUE_STUDIO_4_URL = 'http://127.0.0.1:3777';

const OFFLINE_MESSAGE =
  'Não foi possível falar com o Due Studio. Verifique se ele está aberto e tente novamente.';

export function isInsideDueStudio() {
  return typeof window !== 'undefined' && !!window.__DUE_STUDIO_SESSION__;
}

/**
 * Só existe quando o portal está embutido no app. Não há resposta para aguardar: o app abre
 * o projeto na área de trabalho e avisa o usuário por lá.
 */
export function openProjectInsideDueStudio({ projectId, projectName }) {
  window.chrome.webview.postMessage({
    type: 'open-project',
    projectId,
    projectName,
  });
}

async function requestLocalApp(url, options) {
  const response = await fetch(url, options);
  const text = await response.text();

  if (!response.ok) {
    throw new Error(text || OFFLINE_MESSAGE);
  }

  return text;
}

export function sendProjectToDueStudio5({ projectId, projectName, token }) {
  const params = new URLSearchParams({ projectId: String(projectId) });

  if (projectName) params.append('projectName', projectName);

  return requestLocalApp(`${DUE_STUDIO_5_URL}/open_project?${params}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function sendProjectToDueStudio4({ projectId, token }) {
  return requestLocalApp(`${DUE_STUDIO_4_URL}/download/${projectId}/${token}`, {});
}

export const dueStudioOfflineMessage = OFFLINE_MESSAGE;
